<template>
    <div class="message_container">
        <CustomHeader :text="$t('message.message')" />
        <div class="container">
            <van-tabs v-model:active="active" sticky :ellipsis="false" @click-tab="onClickTab">
                <van-tab v-for="(item, index) in dataSet?.tabList" :key="index" :title="$t(item.name)" :name="index">
                    <div class="content">
                        <MessageCard v-for="item in dataSet?.noticeList" :key="item.id" :messageData="item"
                            :title="setNoticeTypeName(item.type, item.activityName)" :attachement="item.attachment"/>
                        <NoData v-if="dataSet?.noticeList.length == 0" />
                        <van-row v-else-if="dataSet?.totalMsg > dataSet?.pageSize * dataSet?.pageNo">
                            <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                                    @click="getNextPageMsgList"></van-col>
                        </van-row>
                        <div v-else class="no_more">{{ $t('message.noMore') }}</div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, defineEmits, defineProps } from 'vue'
import MessageCard from './components/messageCard.vue';
import CustomHeader from '../components/common/customHeader.vue';
import NoData from '../components/common/noData.vue';
import { MessageData, TAB_LIST } from '@/view/message/supportScript';

const active = ref(0)
const props = defineProps<{
    dataSet: MessageData
}>()
const emits = defineEmits(['onClickTab', 'getNextPageMsgList'])

const setNoticeTypeName = (type: number, activityName : string) => {
    const tab = props.dataSet?.tabList.find(item => item.notice_type === type)
    if(!type){
        return props.dataSet?.activeTab?.name || ''
    }
    if(type == 4){
     return activityName ? activityName : 'message.bonus'
    }else{
        return tab ? tab.name : ''
    }
}
const onClickTab = (value: any) => {
    emits('onClickTab', value)
}

const getNextPageMsgList = () => {
    emits('getNextPageMsgList')
}
</script>
<style scoped>
.message_container {
    padding: 70px 0 ;
}

.container>>>.van-tabs__nav {
    background: transparent;
    width: 90%;
    margin: 0 2.5%;
}

.container>>>.van-tab {
    background: #40294f;
    color: #8b6e8b;
    border-radius: 10px;
    font-size: 13px;
    margin: 3px;
    height: 35px;
    padding: 0 15px;
}

.container>>>.van-tab.van-tab--active {
    background: #ff3d9e;
    color: #fff;
    font-weight: 500;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

.content {
    color: #fff;
    padding: 0 20px;
    flex: 1;
    overflow-y: auto;
    height: calc(100vh - 210px);
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.scrollable-content::-webkit-scrollbar {
    display: none;
}

.top_card {
    background: #3D2E22;
    border: 0.5px solid rgba(221, 122, 51, 0.25);
    border-radius: 10px;
    padding: 15px;
}

.card_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 11.75px;
    padding: 2.5px 0;
}

.card_text span {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.65);
}

.no_more {
    color: #969799;
    display: flex;
    justify-content: center;
    padding: 10px;
    font-size: 14px;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 30px;
    transform: rotate(-90deg);
}
</style>